// @flow
export const BASE: string = process.env.REACT_APP_NAME || 'tandem-admin';

const createStorageKey = key => `${BASE}:${key}`;

export const AUTH_TOKEN = createStorageKey('authToken');
